

export class Constants {
  public static readonly ALL_LANGUAGES = 'all-languages';
  public static readonly SELECT_LANGUAGES = 'select-languages';
  public static readonly AUTH_TOKEN = 'authToken';
  public static readonly AUTH_USER = 'authUser';
  public static readonly FCM_TOKEN = 'fcmToken';
  public static readonly PRODUCT_DATA = 'productData';
  public static readonly SELLING_TYPE = 'sellingType';
  public static readonly PROFILE_URL = 'profileUrl';
  public static readonly SELECT_PREFERENCE = 'select-preference';
  public static readonly SELECT_CITY = 'select-city';
  public static readonly SELECTED_CATEGORIES = 'selectedCategories';
  public static readonly SHOP_ADDRESS = 'shop-address';
  public static readonly SHOP_ID = 'shop-id';
  public static readonly SHOP_NAME = 'shopName';
  public static readonly SHOP_GST = 'shop-gst';
  public static readonly KYC_DETAILS = 'kycDetails';
  public static readonly BANK_DETAILS = 'bankDetails';
  public static readonly WORKING_HOURS = 'working-hours';
  public static readonly MASTER_CATALOGUE = 'masterCatalogueJson';
  public static readonly SUBSCRIPTION = 'retailer-subscrition';
  public static readonly SELECTED_PRODUCT = 'selected_product';
  public static readonly APP_ONLINE_OFFLINE = 'online-offline';
  public static readonly VERSION_CONTROL = 'hh-version_control';
  public static readonly USER_LOCATION = 'hh-user-location';
  public static readonly HOME_STORE = 'hh-home-data';
  // public static readonly VERSION_CONTROL = 'hh-version_control';
  public static readonly CART_DATA = 'hh-cartData';
  public static readonly POS_CUSTOMER_NUMBER = 'hh-pos-user-data';
  public static readonly RETAILER_USER_ID = 'retailer-user-id';
  public static readonly RETAILER_NAME = 'retailer-name';
  public static readonly RETAILER_PHONE = 'retailer-phone';
  public static readonly SHOP_DATA = {
    SHOP_STATUS: 'shop-status',
    USER_ID: 'user-id'
  }

  // pos
  public static readonly FAV_SHOPS = 'hh-fav-shops';
  public static readonly POS_CUSTOMER_USERID = 'hh-pos-user-id';
  public static readonly POS_CUSTOMER_LOCATION = 'hh-pos-user-location';
  public static readonly HELP_VIDEOS = 'help-Videos';

  /* Pay */
  public static readonly AMOUNT = '39900';
  public static readonly PAY_IMAGE = 'https://sarvm.ai/images/app/retailerlogo.png';
  public static readonly CURRENCY = 'INR';
  public static readonly APP_NAME = 'Sarvm';
  public static readonly APP_PRIMARY_COLOR = '#4db965';

  public static readonly ORDER_STATUS = {
    NEW: 1,
    ACCEPTED: 2,
    PROCESSING: 3,
    READY: 4,
    DISPATCHED: 5,
    PICKEDUP: 6,
    IN_TRANSIT: 7,
    DELIVERED: 8,
    COMPLETED: 9,
    REJECTED: 10,
    CANCELLED: 11,
    NO_SHOW: 12
  };
  public static readonly TIMINGS = [
    {
      'time': '6 AM',
    },
    {
      'time': '7 AM',
    },
    {
      'time': '8 AM',
    },
    {
      'time': '9 AM',
    },
    {
      'time': '10 AM',
    },
    {
      'time': '11 AM',
    },
    {
      'time': '12 PM',
    },
    {
      'time': '1 PM',
    },
    {
      'time': '2 PM',
    },
    {
      'time': '3 PM',
    },
    {
      'time': '4 PM',
    },
    {
      'time': '5 PM',
    },
    {
      'time': '6 PM',
    },
    {
      'time': '7 PM',
    },
    {
      'time': '8 PM',
    },
    {
      'time': '9 PM',
    },
    {
      'time': '10 PM',
    },
    {
      'time': '11 PM',
    },
    {
      'time': '12 AM',
    },
    {
      'time': '1 AM',
    },
    {
      'time': '2 AM',
    },
    {
      'time': '3 AM',
    },
    {
      'time': '4 AM',
    },
    {
      'time': '5 AM',
    }
  ];
  public static readonly WeekList = [
    {
      week: 'Monday'
    },
    {
      week: 'Tuesday'
    },
    {
      week: 'Wednesday'
    },
    {
      week: 'Thursday'
    },
    {
      week: 'Friday'
    },
    {
      week: 'Saturday'
    },
    {
      week: 'Sunday'
    }
  ];
  public static readonly schedulingOptions: any = [
    {
      option: "Now",
      img: 'assets/schedule/now.svg',
      value: "NOW"
    },
    {
      option: "Today",
      img: 'assets/schedule/today.svg',
      subOption: [
        {
          optName: 'In 30 mins',
          value: 'IN_30_MIN'
        },
        {
          optName: 'In 1 Hour',
          value: 'IN_1_HOUR'
        },
        {
          optName: 'In 2 Hour',
          value: 'IN_2_HOUR'
        },
        {
          optName: 'In 3 Hour',
          value: 'IN_3_HOUR'
        }
      ]
    },
    {
      option: "Tomorrow",
      img: 'assets/schedule/tomorrow.svg',
      value: "TOMORROW"
    },
  ];
}

export const EmailCheck = (email) => {
  let emailRegex =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(email);
};

export const PhoneCheck = (phone) => {
  let phoneRegex = /^\d{10}$/;
  let number: any = parseInt(phone);
  return phoneRegex.test(number);
};

export const ApiUrls = {
  splash: '/rms/apis/v1/splash',
  order: '/hms/apis/v1/orders',
  catalog: {
    catelog: '/rms/apis/v1/catalog/',
    category: '/hms/apis/v1/households/categories',
    stores: '/hms/apis/v1/households/stores',
    retailerCatalog: '/rms/apis/v1/catalog/',
    elasticSearch: {
      searchSuggestion: '/pss/apis/v1/product/suggestion',
      productSearch: '/pss/apis/v1/productsearch'
    },
    bulkUpdate: {
      bulk_update: '/cms/apis/v1/bulkupdate/retailerProducts',
      getProductByShop: '/cms/apis/v1/retailercatalog/getRetailerProductsDownload',
    },
    customCatalog: {
      add_product: '/cms/apis/v1/newProductReq',
      customCatalogRequests: '/cms/apis/v1/customCatalog',
      customCatalogRequestsByID: '/cms/apis/v1/customCatalog/getCustomCatalogRequests',
      newProductRequestsByID: '/cms/apis/v1/newProductReq/getProductRequests',
    }
  },
  topCustomerReport: {
    existingCustomers: '/report/apis/v1/report/top-customer-report/',
    customerDetail: '/report/apis/v1/report/user-detailed-orders/',
  },
  auth: {
    sendOtp: '/ums/apis/v1/users/send_otp',
    verifyOtp: '/ums/apis/v1/users/verify_otp',
  },
  shop: {
    isShopExists: '/ums/apis/v1/users/isActiveUserShop',
  },
  userDetails: {
    user: '/ums/apis/v1/users',
    profileUpload: '/ums/apis/v1/users/upload',
    getUserDetails: '/ums/apis/v1/users/',
    qrCodeUpload: '/ums/apis/v1/users/QRcodeImage',
    retailerUpi: '/rms/apis/v1/retailers',
    phoneNumber: '/ums/apis/v1/consumerProfile',
    validatePhoneApi: '/ums/apis/v1/users/pos_reg',
  },
  addshop: '/rms/apis/v1/shop',
  catelog: '/rms/apis/v1/catalog/',
  stores: '/hms/apis/v1/households/stores',
  storeMeta: '/hms/apis/v1/households/storeAllData',
  user: '/ums/apis/v1/users',
  image: '/ums/apis/v1/employee/upload',
  category: '/hms/apis/v1/households/categories',
  addgst: 'rms/apis/v1/shop/:shopid/gst',
  getShopDetails: '/rms/apis/v1/shop/details',
  sellerProfile: 'https://uat-static.sarvm.ai/retailer/',
  getGstDetails: '/rms/apis/v1/shop',
  updateShopDetails: '/rms/apis/v1/shop',
  updateShopStatus: '/rms/apis/v1/shop/shopStatus',
  getBankURLDOC: '/onbs/apis/v1/onboarding/retailer/bank/uploadfile',
  addBank: '/onbs/apis/v1/onboarding/retailer/bank',
  createSubscription: '/sub/apis/v1/subscription/initiate',
  confirmSubscription: '/sub/apis/v1/subscription/activate',
  getAllSubscription: '/sub/apis/v1/subscription/',
  checkStatus: '/sub/apis/v1/subscription/status/',
  retailerCatalog: '/rms/apis/v1/catalog/',
  getKycDetails: '/onbs/apis/v1/onboarding/retailer/kyc',
  getAllOrders: '/oms/apis/v1/shop/',
  updateOrders: '/oms/apis/v1/shop/update/',
  orders: '/orders',
  updateQuantity: '/oms/apis/v1/retailer/updatequantity',
  updateOrderStatus: '/rms/apis/v1/orders/',
  updatePayment: '/rms/apis/v1/orders/',
  getOrder: "/rms/apis/v1/orders?status=",
  profileUpload: '/ums/apis/v1/users/upload',
  getShopOwnerDetails: '/rms/apis/v2/shop/',
  updateShopCharges: '/rms/apis/v1/shop/addDeliveryChargesRA?shopId=',
  getDboyList: "/rms/apis/v1/shop/delivery",
  assignOrder: (orderId: any) => `/rms/apis/v1/orders/assign/${orderId}`,
  reAssignOrder: (orderId: any) => `/rms/apis/v1/orders/reAssign/${orderId}`,
  autoAssignOrder: (orderId: any) => `/rms/apis/v1/orders/autoassign/${orderId}`,
  favourites: '/ums/apis/v1/favourite',
  deliveryCharges: '/hms/apis/v1/households/deliveryChargesByOndcIntegration',
  orderReAssign: '/hms/apis/v1/orders/reAssignOrderToRetailer',
  notifications: '/rms/apis/v1/notifications',
  walletService: '/wlt/balance/',
  updatelanguage: '/ums/apis/v1/users/language',
};


